export const Global = {
  apiUrl: 'https://api.renault-trucks.ge/api/'
}
